var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":"Duplicar Rol","value":true},on:{"close-modal":_vm.closeModal}},[_c('role-duplicate-form',{attrs:{"role-id":_vm.id,"role-name":_vm.name}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56379b21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/roles/page-role-duplicate.vue
// module id = 962
// module chunks = 21